<!--查询结果-->
<template>
  <div class="cxjg" @click="handleBodyClick">
    <div class="cxjg-head">
      <div class="cxjg-head-title">班车详情</div>
      <van-icon
        name="arrow-left"
        size="17"
        color="#33639e"
        @click="handleBackClick"
        class="cxjg-head-icon"
      />
    </div>
    <div class="cxjg-body">
      <div class="cxjg-body-title">
        <div class="cxjg-body-title-top">
          <div class="cxjg-body-title-top-dot"></div>
          <div class="cxjg-body-title-top-text" @click.stop="handleStartClick">
            {{ start }}
          </div>
        </div>
        <div class="cxjg-body-title-bottom">
          <div class="cxjg-body-title-bottom-dot"></div>
          <div class="cxjg-body-title-bottom-text" @click.stop="handleEndClick">
            {{ end }}
          </div>
          <div class="cxjg-body-title-bottom-search">
            <div
              class="cxjg-body-title-bottom-search-block"
              @click.stop="handleSearchClick"
            >
              <van-icon
                name="search"
                size="25"
                color="#ffffff"
                style="padding-top: 1px;padding-left: 2px;"
              />
            </div>
          </div>
        </div>
        <div class="change">
          <van-icon
            name="sort"
            size="20"
            color="#0b84f5"
            style="padding-top: 1px;padding-left: 2px;"
            @click.stop="handleChangeClick"
          />
        </div>
        <div class="cxjg-body-title-time">
          <div
            class="cxjg-body-title-time-text"
            @click.stop="handleTimeClick"
            style="left:24px;font-size: 15px;"
          >
            出发时间：{{ time }}
          </div>
        </div>
      </div>
      <div class="cxjg-body-syzd" v-if="startFlag || endFlag">
        <div
          class="cxjg-body-syzd-item"
          v-for="(item, index) in stationList"
          :key="index"
          @click.stop="handelSyzdItemClick(item.station_alias)"
        >
          <div class="cxjg-body-syzd-item-text">{{ item.station_alias }}</div>
        </div>
      </div>
      <div style="height: calc(100% - 100px)" v-else>
        <van-empty
          class="cxjg-body-list"
          v-if="emptyFlag"
          description="无此班车"
        />
        <div class="cxjg-body-list" v-else>
          <div
            class="cxjg-body-list-item"
            v-for="(item, index) in searchLineList"
            :key="index"
            @click="handelItemClick(item)"
          >
            <div class="cxjg-body-list-item-name">{{ item.bc_name }}</div>
            <div class="cxjg-body-list-item-memo" van-ellipsis>
              {{ item.memo }}
            </div>
            <div
              v-if="
                item.is_now == 'true' &&
                  item.runBusInfo != null &&
                  item.runBusInfo.length != 0
              "
            >
              <div class="tw-index-bottom-body-list-item-arrive">
                <span style="color:#3478ff">
                  {{ item.runBusInfo[0].near_distance }}站 </span
                >后到达
              </div>
              <div class="tw-index-bottom-body-list-item-minute">
                大约<span style="color:#09a8ee"
                  >{{ item.runBusInfo[0].about_minute }}分钟</span
                >
              </div>
            </div>
            <div
              class="tw-index-bottom-body-list-item-minute"
              v-if="item.runBusInfo == null && item.is_now == 'true'"
            >
              已过站
            </div>

            <div
              class="tw-index-bottom-body-list-item-minute"
              v-if="item.is_now == 'false'"
            >
              暂未发车
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-datetime-picker
      class="timepicker"
      v-if="timeFlag"
      v-model="currentDate"
      type="datetime"
      title="选择时间"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="handleConfirmClick"
      @cancel="handleTimeCancelClick"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { getSearchLine } from 'api/QueryResultsAPI'
import { getStationList } from 'api/indexAPI'

export default {
  name: 'QueryResults',
  data() {
    return {
      startFlag: false,
      endFlag: false,
      timeFlag: false,
      emptyFlag: false,
      start: '',
      end: '',
      time: '',
      searchLineList: [],
      stationList: [],
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2035, 10, 1),
      currentDate: ''
    }
  },
  mounted() {
    const { start, end, time } = this.$route.query
    this.start = start
    this.end = end
    this.time = time
    this.currentDate = new Date(time)
    this.getSearchLine()
    this.getStationList()
  },
  methods: {
    handleBackClick() {
      window.history.go(-1)
    },
    //根据起点终点查询
    getSearchLine() {
      const params = new URLSearchParams()
      params.append('begin_station', this.start)
      params.append('end_station', this.end)
      params.append('date', moment(this.time).format('YYYY-MM-DD'))
      params.append('time', moment(this.time).format('HH:mm'))
      getSearchLine(params).then(res => {
        if (res.data.data.length == 0) this.emptyFlag = true
        this.searchLineList = res.data.data
      })
    },
    //item点击事件
    handelItemClick(item) {
      this.$router.push({
        path: '/zdxl/xlxq',
        query: { bid: item.bid, near: this.$route.query.near }
      })
    },
    //起点点击事件
    handleStartClick() {
      this.timeFlag = false
      this.startFlag = true
      this.endFlag = false
    },
    //终点点击事件
    handleEndClick() {
      this.timeFlag = false
      this.startFlag = false
      this.endFlag = true
    },
    //时间点击事件
    handleTimeClick() {
      this.timeFlag = true
      this.startFlag = false
      this.endFlag = false
      // this.currentDate = this.time
    },
    handleBodyClick() {
      this.startFlag = false
      this.endFlag = false
    },
    //站点列表item点击事件
    handelSyzdItemClick(val) {
      if (this.startFlag) {
        this.start = val
      } else if (this.endFlag) {
        this.end = val
      }
      this.startFlag = false
      this.endFlag = false
    },
    //搜索
    handleSearchClick() {
      this.getSearchLine()
    },
    //获取所有站点列表
    getStationList() {
      getStationList().then(res => {
        this.stationList = res.data.data
      })
    },
    //时间确认按钮
    handleConfirmClick(value) {
      console.info(value)
      this.time = moment(value).format('YYYY-MM-DD HH:mm')
      this.timeFlag = false
    },
    //时间取消按钮
    handleTimeCancelClick() {
      this.timeFlag = false
    },
    //换向
    handleChangeClick() {
      var mid = this.start
      this.start = this.end
      this.end = mid
      this.getSearchLine()
    }
  }
}
</script>

<style lang="scss" scoped>
.cxjg {
  height: 100%;
  &-head {
    height: 60px;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #ebeced;
    box-sizing: border-box;
    &-title {
      // text-align: center;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 1px;
      padding-top: 5%;
      padding-left: 10%;
      color: #33639e;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 30%;
    }
  }
  &-body {
    height: calc(100% - 60px);
    overflow: auto;
    &-title {
      height: 100px;
      position: relative;
      // display: flex;
      border-bottom: 1px solid #ebeced;
      box-sizing: border-box;
      &-top,
      &-bottom,
      &-time {
        width: 100%;
        height: 33%;
        position: relative;
      }
      &-top-dot,
      &-bottom-dot {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: rgb(10, 180, 47);
        position: absolute;
        left: 7%;
        top: calc(50% - 5px);
      }
      &-bottom-dot {
        background-color: red;
      }
      &-top-text,
      &-bottom-text,
      &-time-text {
        position: absolute;
        font-size: 17px;
        font-weight: 550;
        left: 15%;
        top: calc(50% - 12px);
        box-sizing: border-box;
        padding-top: 5px;
      }
      &-time-text {
        left: 10%;
      }
      &-bottom-search {
        padding-top: 33px;
        &-block {
          width: 29px;
          height: 28px;
          background-color: #0b84f5;
          border-radius: 5px;
          position: relative;
          top: -45%;
          right: -75%;
          z-index: 100;
        }
      }
    }
    &-list {
      height: 100%;
      overflow: auto;
      &-item {
        height: 100px;
        position: relative;
        box-sizing: border-box;
        border-bottom: 1px solid #ebeced;
        &-name,
        &-memo,
        &-start,
        &-end {
          position: absolute;
          font-weight: 550;
          font-size: 14px;
          left: 5%;
          top: 10px;
        }
        &-name {
          font-size: 15px;
          line-height: 17px;
          padding-right: 10px;
        }
        &-memo {
          font-size: 12px;
          top: 78px;
          width: 70%;
          // color: #a9a9a9;
        }
        .icon-right_2 {
          color: #a8acb0;
          position: absolute;
          left: 32%;
          top: 58px;
        }
        &-begin,
        &-endadress {
          color: #a8acb0;
          position: absolute;
          font-weight: 550;
          font-size: 14px;
          left: 5%;
          top: 58px;
        }
        &-endadress {
          left: 45%;
        }
        &-start,
        &-end {
          font-size: 12px;
          top: 80px;
          color: #a8acb0;
        }
        &-end {
          left: 30%;
        }
      }
    }
    &-syzd {
      height: calc(100% - 100px);
      overflow: auto;
      &-item {
        height: 50px;
        box-sizing: border-box;
        border-bottom: 1px solid #d8d9e2;
        &-text {
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          padding-left: 40px;
          font-size: 15px;
          font-weight: 550;
        }
      }
    }
  }
}
.timepicker {
  z-index: 101;
  height: 38%;
  width: 100%;
  position: absolute;
  bottom: 0px;
}
.change {
  right: 30%;
  top: 25%;
  position: absolute;
}
</style>
